import {Injectable} from '@angular/core';

import {HttpClient, HttpHeaders, HttpParams, HttpRequest} from '@angular/common/http';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ListingDetailService {

  constructor(private http: HttpClient) {
  }

  getHouseholdItems(url: string) {
    return this.http.get(url);
  }

  getCounties(url: string, param: string) {
    return this.http.get(url + param);
  }

  getLikes(url: string, param: string) {
    let params = new HttpParams();
    params = params.append('id', param);
    return this.http.get(url , {params:params});
  }

  getItem(url: string, motors: string, id: string, profile?: string | null, context?: Record<string, unknown>) {
    let params = new HttpParams();
    params = params.append('id', id);
    if (profile) {
      params = params.append('profile', profile);
    }
    let headers = new HttpHeaders();
    if (context && Object.keys(context).length > 0) {
      headers = headers.set('X-Data', btoa(JSON.stringify(context)));
    }
    return this.http.get(url + '/item' + motors, {params, headers});
  }

  getSearchItem(url: string, itemName : string) {
    let params = new HttpParams();
    params = params.append('itemName', itemName);
    return this.http.get(url + '/item/category', {params:params});
  }

  getSearchItems(url: string, category : string, subcategory : string) {
    let params = new HttpParams();
    params = params.append('category', category);
    params = params.append('subcategory', subcategory);
    return this.http.get(url + '/item/categories', {params:params});
  }

  getSidebarItems(url: string) {
    return this.http.get(url);
  }
}

/** @deprecated Use ListingDetailService */
export {ListingDetailService as AllViewItemService};
